<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-layout class="d-flex justify-space-between flex-wrap">
            <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                Filtrar por:
                <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
            </v-btn>
            <v-btn class="px-md-5 px-10 transition mt-2" v-if="activetab === GROUPED_QUERIES" color="primary" @click="download()">SALVAR RELATÓRIO</v-btn>
        </v-layout>
        <collapse-transition>
            <m-form ref="filter"
                    class="mt-8"
                    v-show="filter_open">
                <v-row>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DateRange v-model="filter.dataRange" @filter="filtrar()" :shortcut="true" label="Data das consultas" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DynamicSelect label="Usuário: "
                                       v-model="filter.user"
                                       endpoint="/dynamic-selects/usuarios/login"
                        />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <div>
                            <Autocomplete class="mb-6" label="Ponto de venda:"
                                          :items="pontos_venda"
                                          item-text="showText" item-value="cod_ponto_venda"
                                          v-model="filter.ponto_venda"
                                          placeholder="Selecione os pontos de venda" multiple hide-details
                                          :close-button-on-left="true" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <div>
                            <Autocomplete lass="mb-6" label="Comissionado:"
                                          :items="comissionados"
                                          v-model="filter.comissionado"
                                          item-text="showText" item-value="cod_comissionado"
                                          placeholder="Selecione os comissionados" multiple hide-details
                                          :close-button-on-left="true" />
                        </div>
                    </v-col>
                </v-row>
                <v-row class="justify-end mt-4">
                    <v-col cols="6" sm="3">
                        <v-btn color="secondary" block @click="cleanFilter()">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <v-btn color="primary" block @click="filtrar()">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </m-form>
        </collapse-transition>
        <br>
        <br>
        <hr style="border: 1px solid #ccc">
        <h2 class="title-date mt-5" v-show="custom_filter.dataRange[0] !== '' && custom_filter.dataRange[1] !== '' && custom_filter.dataRange[0] !== null && custom_filter.dataRange[1] !== null">{{ getDates() }}</h2>
        <DataTable
                url="painel/listar/consultas-agrupadas/credito-analise"
                :headers="headers"
                :params="params"
                class="listagem mt-3"
                :show-total="true"
                :cell-total="['qtd_consultas', 'qtd_venda_convertida']"
                ref="datatable">
            <template v-slot:items="{item}">
                <td>
                    <v-tooltip v-if="showIconAttention(item)" bottom color="#222">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <div class="d-flex">
                                    <v-icon size="18" color="primary">warning</v-icon>
                                </div>
                            </span>
                        </template>
                        <p class="mb-0" style="color:whitesmoke;max-width: 250px;">Usuário com vendas bloqueadas. Consultas com situação de crédito em análise ou reprovadas!</p>
                    </v-tooltip>
                </td>
                <td>
                    {{ (item.login || '') + ' - '+ (item.nome || '') }}
                </td>
                <td>{{ (item.cod_ponto_venda || '') + ' - ' + (item.nome_ponto_venda || '') }}</td>
                <td>{{ item.cod_comissionado + ' - ' + item.nome_comissionado }}</td>
                <td>{{ item.qtd_consultas }}</td>
                <td>{{ item.qtd_venda_convertida }}</td>
                <td><v-icon @click="details(item)">mdi-file</v-icon></td>
            </template>
        </DataTable>
    </v-container>
</template>

<script>
  import moment from 'moment'
  import { notification } from '../../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'GroupedQueries',
    props: {},
    data: () => ({
      filter_open: false,
      headers: [
        { text: '', sortable: false },
        { text: 'Usuário', value: 'login' },
        { text: 'Ponto de venda', value: 'cod_ponto_venda' },
        { text: 'Comissionado', value: 'cod_comissionado' },
        { text: 'Quantidade de consultas Motor', value: 'qtd_consultas' },
        { text: 'Quantidade de vendas', value: 'qtd_venda_convertida' },
        { text: 'Detalhes', sortable: false }
      ],
      filter: {
        dataRange: ['', ''],
        user: [],
        ponto_venda: [],
        comissionado: []
      },
      custom_filter: {
        dataRange: ['', ''],
        user: [],
        ponto_venda: [],
        comissionado: []
      },
      usuarios: [],
      pontos_venda: [],
      comissionados: [],
      currentDate: new Date()
    }),
    computed: {
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15
          },
          filters: this.custom_filter
        }
      },
      firstDayMonth () {
        const primeiroDia = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1)
        return this.formatarData(primeiroDia)
      },
      lastDayMonth () {
        const ultimoDia = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0)
        return this.formatarData(ultimoDia)
      }
    },
    created () {
      this.filter.dataRange[0] = this.firstDayMonth
      this.filter.dataRange[1] = this.lastDayMonth
      this.custom_filter.dataRange[0] = this.firstDayMonth
      this.custom_filter.dataRange[1] = this.lastDayMonth
    },
    mounted () {
      this.getFilters()
    },
    methods: {
      async getFilters () {
        await this.$http
          .get('/painel/get-filters/credito-analise')
          .then((result) => {
            if (result.data) {
              this.usuarios = result.data.users
              this.pontos_venda = result.data.pontos_venda
              this.comissionados = result.data.comissionados
            }
          })
          .catch((err) => notification('error', err, 'Não foi possível buscar os filtros!'))
      },
      filtrar () {
        this.custom_filter = null
        this.$nextTick(() => {
          this.custom_filter = { ...this.filter }
          this.reload()
        })
      },
      cleanFilter () {
        this.filter = {
          dataRange: ['', ''],
          endDate: '',
          user: [],
          ponto_venda: [],
          comissionado: []
        }

        this.$nextTick(() => {
          this.custom_filter = { ...this.filter }
          this.reload()
        })
      },
      reload () {
        this.$refs.datatable.reload()
      },
      showIconAttention (item) {
        return item.exibir_icon_atencao > 0
      },
      getDates () {
        const format = 'YYYY-MM-DD'
        const data_inicial = moment(this.custom_filter.dataRange[0], format)
        const data_final = moment(this.custom_filter.dataRange[1], format)
        return `${data_inicial.format('DD/MM/YYYY')} a ${data_final.format('DD/MM/YYYY')}`
      },
      formatarData (data) {
        const ano = data.getFullYear()
        const mes = (data.getMonth() + 1).toString().padStart(2, '0')
        const dia = data.getDate().toString().padStart(2, '0')
        return `${ano}-${mes}-${dia}`
      },
      download () {
        const encoded_params = Qs.stringify({
          filters: this.filter,
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/credit-analysis/download?${encoded_params}`)
      },
      details (item) {
        item.datas = [this.custom_filter.dataRange[0], this.custom_filter.dataRange[1]]
        item.user = this.custom_filter.user
        this.$emit('goToDetails', item)
      }
    }
  }
</script>

<style scoped>
    .div--comboBox {
        width: 65%;
        overflow: auto;
        max-height: 250px;
    }
</style>
